import React from 'react';
export const Track = ({ source, target, getTrackProps, disabled, onHover }) => {
    // your own track component
    return (React.createElement("div", Object.assign({ onMouseEnter: () => onHover(true), onMouseLeave: () => onHover(false), style: {
            position: 'absolute',
            height: 6,
            zIndex: 1,
            backgroundColor: disabled ? '#999' : '#0b6bf2',
            cursor: 'pointer',
            left: `${source.percent}%`,
            width: `${target.percent - source.percent}%`,
        } }, getTrackProps())));
};
//# sourceMappingURL=Track.js.map